import * as React from 'react';
import { mergeProps } from '../../merge-props/index.js';
export function usePreviewCardPopup(params) {
  const {
    getProps
  } = params;
  const getPopupProps = React.useCallback((externalProps = {}) => {
    return mergeProps({
      style: {
        // <Popover.Arrow> must be relative to the <Popover.Popup> element.
        position: 'relative'
      }
    }, getProps(externalProps));
  }, [getProps]);
  return React.useMemo(() => ({
    getPopupProps
  }), [getPopupProps]);
}